module.exports = __webpack_public_path__ + "assets/img/why.66f1dba5.png";